import { FilterMatchMode } from 'primereact/api';
import { getContrastTextColor } from '../../utils/FuncionesGenericas';
import { InputTextarea } from 'primereact/inputtextarea';
import { Tooltip } from 'primereact/tooltip';

export class TablaTransaccional {

    constructor(tablaTemporal = false) {
        this.model = {
            nombres: {
                header: 'Nombre',
                table: true,
                sort: true,
                filter: true,
                frozen: true,
                matchMode: FilterMatchMode.CONTAINS,
                filterPlaceholder: 'Búsqueda',
                style: { minWidth: '200px' },
                bodyTemplate: 'nombreConAcciones' // Requiere lógica del padre (Menu)
            },
            identificacion: {
                header: 'Identificación',
                table: true,
                sort: true,
                filter: true,
                matchMode: FilterMatchMode.CONTAINS,
                style: { minWidth: '200px' }
            },
            ingreso_mensual_neto: {
                header: 'Ingreso Mensual Neto',
                table: true,
                sort: true,
                filter: true,
                isNumeric: true, // Esto activa FiltroNumerico y OpcionesFiltroNumerico en tu TablaDinamica
                // isCurrency: true, // <--- Opcional: Si quieres que se formateé con $ en el cuerpo automáticamente descomenta esto
                matchMode: FilterMatchMode.EQUALS,
                filterPlaceholder: 'Búsqueda',
                style: { minWidth: '200px' }
            },
            total_transaccion: {
                header: 'Total transaccionado / Cuota / Abono',
                table: true,
                sort: true,
                filter: true,
                isNumeric: true,
                matchMode: FilterMatchMode.EQUALS,
                filterPlaceholder: 'Búsqueda',
                style: { minWidth: '200px' }
            },
            inversion: {
                header: 'Umbral mínimo parametrizado',
                table: true,
                sort: true,
                filter: true,
                isNumeric: true,
                matchMode: FilterMatchMode.EQUALS,
                filterPlaceholder: 'Búsqueda',
                style: { minWidth: '200px' }
            },
            q1: {
                header: 'Q1',
                table: true,
                sort: true,
                filter: true,
                isNumeric: true,
                matchMode: FilterMatchMode.EQUALS,
                filterPlaceholder: 'Búsqueda',
                style: { minWidth: '200px' }
            },
            mediana: {
                header: 'Mediana',
                table: true,
                sort: true,
                filter: true,
                isNumeric: true,
                matchMode: FilterMatchMode.EQUALS,
                filterPlaceholder: 'Búsqueda',
                style: { minWidth: '200px' }
            },
            q3: {
                header: 'Q3',
                table: true,
                sort: true,
                filter: true,
                isNumeric: true,
                matchMode: FilterMatchMode.EQUALS,
                filterPlaceholder: 'Búsqueda',
                style: { minWidth: '200px' }
            },
            maximo: {
                header: 'Máximo',
                table: true,
                sort: true,
                filter: true,
                isNumeric: true,
                matchMode: FilterMatchMode.EQUALS,
                filterPlaceholder: 'Búsqueda',
                style: { minWidth: '200px' }
            },
            nivel_de_riesgo: {
                header: 'Riesgo por Desviación de Perfil Económico',
                table: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'riesgos',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '150px' },
                body: (rowData) => badgeBody(rowData.nivel_riesgo, rowData.color_nivel_riesgo)
            },
            alerta_temprana: {
                header: 'Alerta Temprana',
                table: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'alertas',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '100px' },
                body: (rowData) => badgeBody(rowData.al_temprana, rowData.color_al_temprana)
            },
            numero_transacciones: {
                header: 'No. Transacciones',
                table: true,
                sort: true,
                filter: true,
                isNumeric: true,
                matchMode: FilterMatchMode.EQUALS,
                style: { minWidth: '200px' }
            },
            alerta: { // Alerta por Número de Transacciones
                header: 'Alerta No. Transacciones',
                table: true,
                filter: true,
                filterField: 'alerta', // Nombre del filtro en el back
                isMultiselect: true,
                catalogKey: 'riesgos',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '150px' },
                body: (rowData) => badgeBody(rowData.alerta1, rowData.color_alerta)
            },
            menor_inversion_esperada: {
                header: 'Umbral transacción',
                table: true,
                isCurrency: true, // Formateará automático si TablaDinamica lo soporta
                style: { minWidth: '150px' }
            },
            alerta_5000: {
                header: 'Transacciones superan el Umbral',
                table: true,
                filter: true,
                filterField: 'alerta_5000',
                isMultiselect: true,
                catalogKey: 'supera',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '150px' },
                body: (rowData) => badgeBody(rowData.alerta5000, rowData.color_alerta5000)
            },
            tipo_medio_pago: {
                header: 'Medio de Pago',
                table: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'tiposMedioPago',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '150px' }
            },
            valor_medio_pago: {
                header: 'Valor Medio Pago',
                table: true,
                sort: true,
                filter: true,
                isNumeric: true,
                style: { minWidth: '150px' },
                body: (rowData) => circuloBody(rowData.medio_pago_valor, rowData.color_medio_pago)
            },
            alerta_medio_pago: {
                header: 'Alerta Medio Pago',
                table: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'riesgos',
                style: { minWidth: '150px' },
                body: (rowData) => badgeBody(rowData.medio_pago, rowData.color_medio_pago)
            },
            fecha_proceso: {
                header: 'Fecha Proceso',
                table: true,
                style: { minWidth: '150px' }
            },
            nivel_mayor_alerta: {
                header: 'Nivel de Mayor Alerta',
                table: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'riesgos',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '150px' },
                body: (rowData) => badgeBody(rowData.nivel_mayor_alerta, rowData.color_nivel_mayor_alerta)
            },
        }

        if (!tablaTemporal) {
            this.model.justificacion = {
                field: 'justifica_alerta_id', // Nombre en el back
                header: 'Justificación',
                table: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'justificaciones',
                sort: false,
                style: { minWidth: '150px' },
                bodyTemplate: 'justificacionBody', // Definido en el padre
            };
            this.model.comentario = {
                header: (
                    <div className="flex align-items-center gap-2">
                        <span>Comentario</span>
                        <Tooltip target=".tooltip-info-comentario" position="top" />
                        <i
                            className="pi pi-question-circle tooltip-info-comentario text-primary"
                            style={{ cursor: 'help' }}
                            data-pr-tooltip="Clic en el lápiz a la derecha para editar el comentario"
                        />
                    </div>
                ),
                table: true,
                field: 'comentario',
                filter: false,
                style: { minWidth: '250px' },
                bodyTemplate: 'comentarioBody', // Definido en el padre
                editor: textEditor
            };
        }
    }
};

const badgeBody = (valor, colorHex) => {
    if (!colorHex) return valor;
    const bg = `#${colorHex.replace('#', '')}`;
    const fg = getContrastTextColor(bg);
    return (
        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', minWidth: '100px' }}>
            <span style={{
                backgroundColor: bg, color: fg, padding: '0.25em 0.5em',
                borderRadius: '0.25rem', display: 'inline-block', fontWeight: 'bold', fontSize: '0.9rem'
            }}>
                {valor}
            </span>
        </div>
    );
};

const circuloBody = (valor, colorHex) => {
    const bg = `#${colorHex?.replace('#', '') || 'ccc'}`;
    const fg = getContrastTextColor(bg);
    return (
        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', minWidth: '100px' }}>
            <span style={{
                backgroundColor: bg, color: fg, width: '2em', height: '2em', borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold'
            }}>
                {valor}
            </span>
        </div>
    );
};

const textEditor = (options) => {
    // Límite de caracteres para el comentario
    const maxLength = 500;
    const value = options.value || '';
    const length = value.length;
    const isLimitReached = length >= maxLength;
    return (
        <div className="flex flex-column w-full">
            <InputTextarea id={options.field} value={value} onChange={(e) => options.editorCallback(e.target.value)} rows={2} autoResize maxLength={maxLength} style={{ width: '100%' }} placeholder="Escribir comentario o justificación..." />
            {maxLength && (
                <small style={{ color: isLimitReached ? 'red' : '#6c757d', textAlign: 'right', display: 'block', marginTop: '4px' }}>
                    {length} / {maxLength} caracteres
                </small>
            )}
        </div>
    );
};